export default {
    LOAD_NF_ITENS(state, nf_itens) {
        state.items = nf_itens;
    }
}